import axios from "../../axios";
import { Commit, Dispatch } from 'vuex'
import router from "@/router";

const email = process.env.VUE_APP_EMAIL_URL;
const baseURL = email + "users";

export default ({
    namespaced: true,
    state : {
        users: [],
        status: 'loading',
    },
    actions : {
        async activate({dispatch}: {dispatch: Dispatch}, payload={id: ''}){
            const { data } = await axios.put(`${baseURL}/activate/${payload.id}`, payload);
            return data
        },
        async update({dispatch}: {dispatch: Dispatch}, payload={id: ''}){
            const { data } = await axios.put(`${baseURL}/business-unit-users/${payload.id}`, payload);
            dispatch('index');
            return data
        },
    },
});
